import { render, staticRenderFns } from "./AddServiceBusiness.vue?vue&type=template&id=71703ffa&scoped=true"
import script from "./AddServiceBusiness.vue?vue&type=script&lang=js"
export * from "./AddServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./AddServiceBusiness.vue?vue&type=style&index=0&id=71703ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71703ffa",
  null
  
)

export default component.exports